import { FC, useCallback } from 'react';
import { EntityLinkAction, EntityLinkVariant } from '../entity-link/helpers';
import useDrawer from '@/hooks/use-drawer.hook';
import { useNavigate } from '@tanstack/react-router';
import { EntityLink } from '../entity-link';
import { ConnectorModel } from '@/lib/models/connector/connector.model';

interface Props {
  connector: ConnectorModel;
  variant?: EntityLinkVariant;
  action?: EntityLinkAction;
  showType?: boolean;
}

const ConnectorLink: FC<Props> = ({
  connector,
  variant = 'text',
  action = 'drawer',
  showType = false,
}) => {
  const navigate = useNavigate();
  const { openDrawer } = useDrawer();
  const { id, name, typeLabel } = connector;

  const handleClick = useCallback(() => {
    if (action === 'drawer') {
      openDrawer('connector', { id });
      return;
    }

    navigate({
      to: '/config/connectors',
      search: { drawer: 'connector', dp_id: id },
    });
  }, [id, navigate, openDrawer, action]);

  const hasClick = !!id && action !== 'none';

  return (
    <EntityLink
      title={name}
      subtext={showType ? typeLabel : undefined}
      onClick={hasClick ? handleClick : undefined}
      variant={variant}
    />
  );
};

export default ConnectorLink;
